import { ApiError } from './apiError'

/** Ordinary JSON requests. */
export const DEFAULT_REQUEST_TIMEOUT_MS = 30_000
/** Multipart uploads and file downloads/exports on slow mobile links. */
export const LONG_REQUEST_TIMEOUT_MS = 120_000

export const REQUEST_TIMEOUT_CODE = 'REQUEST_TIMEOUT'

/**
 * `fetch()` with a deadline.
 *
 * A plain `fetch()` never settles when the connection stalls mid-response
 * (seen in production over HTTP/3 on flaky networks), which leaves the UI on
 * an endless spinner. Past the deadline the request is aborted with an
 * `ApiError` coded `REQUEST_TIMEOUT` as the reason, so both `fetch()` and a
 * later `response.json()` / `.text()` reject into the caller's normal error
 * path. The deadline covers reading the body too, which is why the timer is
 * not cleared once headers arrive; aborting a finished request is a no-op.
 * A caller-supplied `signal` still cancels as before.
 */
export function fetchWithTimeout(
  input: RequestInfo | URL,
  init: RequestInit = {},
  timeoutMs: number = init.body instanceof FormData
    ? LONG_REQUEST_TIMEOUT_MS
    : DEFAULT_REQUEST_TIMEOUT_MS,
): Promise<Response> {
  const controller = new AbortController()
  const callerSignal = init.signal
  if (callerSignal) {
    if (callerSignal.aborted) controller.abort(callerSignal.reason)
    else
      callerSignal.addEventListener('abort', () => controller.abort(callerSignal.reason), {
        once: true,
      })
  }

  setTimeout(() => {
    controller.abort(
      new ApiError({
        message: 'Server tidak merespons. Periksa koneksi internet Anda lalu coba lagi.',
        code: REQUEST_TIMEOUT_CODE,
        status: 0,
      }),
    )
  }, timeoutMs)

  return fetch(input, { ...init, signal: controller.signal })
}
